import { apiFetch } from "@/client/lib/api";

/**
 * Customer-facing no-disruption holds API. Holds are tenant-owned requests not
 * to disrupt the tenant's work during a window; any active customer in the
 * tenant can create, edit, or cancel them. RLS scopes everything to the tenant.
 */

export type HoldStatus = "active" | "cancelled";

export interface Hold {
  id: string;
  title: string;
  description: string;
  affectedScope: string;
  startsAt: string;
  endsAt: string;
  status: HoldStatus;
  createdByUserId: string | null;
  createdByName: string | null;
  createdAt: string;
}

export interface HoldInput {
  title: string;
  description: string;
  affectedScope: string;
  startsAt: string;
  endsAt: string;
}

export const holdsApi = {
  list: () => apiFetch<{ holds: Hold[] }>("/holds"),
  create: (input: HoldInput) => apiFetch<Hold>("/holds", { method: "POST", json: input }),
  update: (id: string, input: Partial<HoldInput>) =>
    apiFetch<Hold>(`/holds/${id}`, { method: "PATCH", json: input }),
  cancel: (id: string) => apiFetch<Hold>(`/holds/${id}/cancel`, { method: "POST" }),
};
